export default {
    beats: {
        title: "BEATS AND PERCS",
        text: "Beats from space",
        releases: [{
            id: 1,
            title: 'Prelude and outer space',
            tracks: [{
                artist: "Roll le Barge",
                name: "Initial Singularity",
                stems: [{
                    id: 1,
                    name: 'DrumBus',
                    link: "https://drive.google.com/file/d/1-2rUjpoTVMmMzSV2JQqU5xCh8FWeo4MM/view?usp=sharing"
                }]
            }, {
                artist: "Wearamask",
                name: "La Fête est Finie",
                stems: [{
                    id: 1,
                    name: 'Kick_BDPunch',
                    link: "https://drive.google.com/file/d/1sTj8ipPvRdoZ6aeQpyKiWWUSrZdtP-42/view?usp=sharing"
                }, {
                    id: 2,
                    name: 'Percs_DrumRack',
                    link: "https://drive.google.com/file/d/10NDmqkUWBueY265rmgnBw_56CkXXNOhh/view?usp=sharing"
                }, {
                    id: 3,
                    name: 'Percs_Snare',
                    link: "https://drive.google.com/file/d/1aLmu5CRrlI_ZdIpde3uya0Pe6jMcASnb/view?usp=sharing"
                }, ]
            },{
                artist: "Rayleigh",
                name: "Bending Gravity",
                stems: [{
                    id: 1,
                    name: 'Drumbus',
                    link: "https://drive.google.com/file/d/1eoCcKb4z5nruJJDg2OX5JQKp11x3qpgi/view?usp=sharing"
                }]
            }, {
                artist: "Parazar",
                name: "Founding Fader",
                stems: [{
                    id: 1,
                    name: 'Drumbus',
                    link: "https://drive.google.com/file/d/10T6-zbQX7Ei00MzN7lDSj4OFmERsv8P8/view?usp=sharing"
                },{
                    id: 2,
                    name: 'KickBassLead',
                    link: "https://drive.google.com/file/d/1BVxGZ-TINqltImfvuFZGM3RT4u77970A/view?usp=sharing"
                }]
            }, ]
        }]

    },
    synths: {
        title: "SYNTHS, VOX AND FX",
        text: "Beats from space",
        releases: [{
            id: 1,
            title: 'Prelude and outer space',
            tracks: [{
                artist: "Roll le Barge",
                name: "Initial Singularity",
                stems: [{
                    id: 1,
                    name: 'Voix1',
                    link: "https://drive.google.com/file/d/1FY1LVYEY7kpqtXcc9YhvTEbtVzICIIRU/view?usp=sharing"
                }, {
                    id: 2,
                    name: 'Voix2',
                    link: "https://drive.google.com/file/d/1WkbBg9X1yzsqi4uSYUeycFAM4pyVJCSj/view?usp=sharing"
                },{
                    id: 3,
                    name: 'Prophet1',
                    link: "https://drive.google.com/file/d/1uHT9YmeAGh-Zjlj8nbyFsrx6gM4_4U-G/view?usp=sharing"
                },{
                    id: 4,
                    name: 'Prophet2',
                    link: "https://drive.google.com/file/d/1SSlbLuDaes6rSKiR_3DtZFATH1RW4KNR/view?usp=sharing"
                },{
                    id: 5,
                    name: 'Prophet3',
                    link: "https://drive.google.com/file/d/10Jq0Gu1Olv0q0z68lawjLEfiaxJsheOX/view?usp=sharing"
                },{
                    id: 6,
                    name: 'Pad',
                    link: "https://drive.google.com/file/d/1tIOuf7jIfTVcpBtOOyIKejDWA9CU5XnK/view?usp=sharing"
                }, {
                    id: 7,
                    name: 'GroupSynth',
                    link: "https://drive.google.com/file/d/1QNJgbqk7YrKRsowBomyRuM1ooDbg9lUJ/view?usp=sharing"
                },{
                    id: 8,
                    name: 'FXs',
                    link: "https://drive.google.com/file/d/1YzieD6rZtvBoHGONN81RNkTRA890HMfd/view?usp=sharing"
                },{
                    id: 9,
                    name: 'Chords',
                    link: "https://drive.google.com/file/d/1MqVe46f8_FwI8EQ87DESBrLLWDJqaoWk/view?usp=sharing"
                },{
                    id: 10,
                    name: 'Chords1',
                    link: "https://drive.google.com/file/d/1y83J6LRqqUOO3PFts7qRK4x_nJmEtuSQ/view?usp=sharing"
                },  ]
            }, {
                artist: "Wearamask",
                name: "La Fête est Finie",
                stems: [{
                        id: 1,
                        name: 'Synth_Predator',
                        link: "https://drive.google.com/file/d/1Ayls_877XAspKnyFUv7P8T-KETCILuLC/view?usp=sharing"
                    }, {
                        id: 2,
                        name: 'FX_Blue',
                        link: "https://drive.google.com/file/d/1HgMDXqITl7ycmP9DhScv7gHR1FsYCKCZ/view?usp=sharing"
                    },
                    {
                        id: 3,
                        name: 'FX_Blue2',
                        link: "https://drive.google.com/file/d/1A0WzzoPp7O8g51wpncFS912IyZR-xU1a/view?usp=sharing"
                    }, {
                        id: 4,
                        name: 'Synth(main)_Predator2',
                        link: "https://drive.google.com/file/d/12NIr4wRxl3ARr8SPLF_aDCOXFYCKuLpq/view?usp=sharing"
                    },
                    {
                        id: 5,
                        name: 'Synth(main)_Synth',
                        link: "https://drive.google.com/file/d/1GfcMH7F6mLrYMTgJE39njW_XMYpnZC-y/view?usp=sharing"
                    },
                ]
            },{
                artist: "Rayleigh",
                name: "Bending Gravity",
                stems: [{
                        id: 1,
                        name: 'Arpeggiator_Arp',
                        link: "https://drive.google.com/file/d/1oJi7lcwmNjiZa6_e8mxHwvlkImskwZ8y/view?usp=sharing"
                    }, {
                        id: 2,
                        name: 'FX_Break toms',
                        link: "https://drive.google.com/file/d/1D46m-1dQDr3PiH1DsANhMuNKKgXaveHo/view?usp=sharing"
                    }, {
                        id: 3,
                        name: 'FX_Grrrr',
                        link: "https://drive.google.com/file/d/1zGvoK2ZUDEb5BSlM2MSGMz8y5FUsZdvC/view?usp=sharing"
                    },
                    {
                        id: 4,
                        name: 'FX_Loop',
                        link: "https://drive.google.com/file/d/1LeLFBeEq6zug1_2UOxrGZsCmuQRBjis0/view?usp=sharing"
                    },
                    {
                        id: 5,
                        name: 'Pad_Pads',
                        link: "https://drive.google.com/file/d/1iM5NvqMPhFNxSoi5b_UOYyolpeZ3rLCX/view?usp=sharing"
                    },
                ]
            }, {
                artist: "Parazar",
                name: "Founding Fader",
                stems: [{
                    id: 1,
                    name: 'Vox',
                    link: "https://drive.google.com/file/d/1pp6easpDGW6AIQFr8-NCwfTBcNv10hBo/view?usp=sharing"
                },{
                    id: 2,
                    name: 'BleepsChordsLead',
                    link: "https://drive.google.com/file/d/1Ydu6PWH3hpVTbufEBXab5z8LhRCNsnr2/view?usp=sharing"
                },]
            }, ]
        }]

    },
    basses: {
        title: "LOUDNESS AND BASSES",
        text: "Beats from space",
        releases: [{
            id: 1,
            title: 'Prelude and outer space',
            tracks: [{
                artist: "Roll le Barge",
                name: "Initial Singularity",
                stems: [{
                    id: 1,
                    name: 'Bass',
                    link: "https://drive.google.com/file/d/1SU9kw-aph2h5R1tyZqy8Xnk7MaZVgl_O/view?usp=sharing"
                }, {
                    id: 2,
                    name: 'Sub',
                    link: "https://drive.google.com/file/d/1eQyX3suixr_lcLDyynMxlOjBJNAlwMA_/view?usp=sharing"
                },{
                    id: 3,
                    name: 'Acid',
                    link: "https://drive.google.com/file/d/1NxSV-OsijGmIMWsG5DyyCn5ayFlLboTd/view?usp=sharing"
                },  ]
            }, {
                artist: "Wearamask",
                name: "La Fête est Finie",
                stems: [{
                    id: 1,
                    name: 'SubBoomBass',
                    link: "https://drive.google.com/file/d/1s4bC8EWgM8YoRvfuPj6_9pIYBnWazIvk/view?usp=sharing"
                }, {
                    id: 2,
                    name: 'SubBoomBass1',
                    link: "https://drive.google.com/file/d/1-0iq5gX7Rh8EzrmlRPEj1ZBWAIlxu3oZ/view?usp=sharing"
                },]
            },{
                artist: "Rayleigh",
                name: "Bending Gravity",
                stems: [{
                    id: 1,
                    name: 'Acid',
                    link: "https://drive.google.com/file/d/1awBkPveq10EOnmJ6QUTHqIJM6k2nhFzM/view?usp=sharing"
                }, {
                    id: 2,
                    name: 'Sub',
                    link: "https://drive.google.com/file/d/11cCXf2TsHirFlWyetKRPIT-_CtCbG1Qa/view?usp=sharing"
                }, {
                    id: 3,
                    name: 'Blasting Bass',
                    link: "https://drive.google.com/file/d/1mzzL7qku62n485dYTLivUSYBB_W5CNwd/view?usp=sharing"
                }, ]
            }, {
                artist: "Parazar",
                name: "Founding Fader",
                stems: [{
                    id: 1,
                    name: 'KickBassLead',
                    link: "https://drive.google.com/file/d/1BVxGZ-TINqltImfvuFZGM3RT4u77970A/view?usp=sharing"
                }]
            }, ]
        }]
    },
}